var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3011",
    "data-name": "Grupo 3011",
    transform: "translate(-30 -398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2441",
    "data-name": "Grupo 2441",
    transform: "translate(-1 114)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1288",
    "data-name": "Ret\\xE2ngulo 1288",
    width: 34,
    height: 34,
    rx: 10,
    transform: "translate(31 284)",
    fill: "#87cbfe",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-air",
    "data-name": "Icon metro-air",
    d: "M5.317,8.306c1.28-1.1,2.292-1.969,5.037-.418A6.7,6.7,0,0,0,13.62,8.913a5.109,5.109,0,0,0,3.424-1.607.76.76,0,0,0,.089-1.055A.723.723,0,0,0,16.1,6.159c-1.28,1.1-2.292,1.97-5.037.418-3.627-2.047-5.326-.589-6.69.584a.76.76,0,0,0-.089,1.055.723.723,0,0,0,1.033.09ZM16.1,9.9c-1.28,1.1-2.292,1.97-5.037.418-3.627-2.049-5.326-.589-6.69.583a.76.76,0,0,0-.089,1.055.722.722,0,0,0,1.033.092c1.28-1.1,2.292-1.969,5.037-.419a6.7,6.7,0,0,0,3.267,1.026,5.1,5.1,0,0,0,3.424-1.609.759.759,0,0,0,.089-1.054A.723.723,0,0,0,16.1,9.9Zm0,3.742c-1.28,1.1-2.292,1.97-5.037.419-3.627-2.049-5.326-.59-6.69.583A.76.76,0,0,0,4.284,15.7a.722.722,0,0,0,1.033.09c1.28-1.1,2.292-1.968,5.037-.418A6.715,6.715,0,0,0,13.62,16.4a5.11,5.11,0,0,0,3.424-1.609.76.76,0,0,0,.089-1.055.724.724,0,0,0-1.033-.092Z",
    transform: "translate(36 404.37)",
    fill: "#87cbfe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.f5b1a81933278b13c971c95dc802a678.svg";
export { ForwardRef as ReactComponent };